module.exports = __webpack_public_path__ + "static/media/dikshantgoyal.cd314e91.jpg";